import { MotifFileUploader, MotifFileUploaderItem, MotifFormField } from '@ey-xd/motif-react'
import React, { useCallback, useState } from 'react'

const ReportsUploadTemplate = ({file, setFile}) => {
    // const [file, setFile] = useState<any>(undefined);

    const onDrop = useCallback((acceptedFiles) => {
        setFile(acceptedFiles)
    }, []);
    const renderFileSelect = useCallback(() => {
        return (
            <MotifFormField onChange={event => {
                setFile(event.target.files)
            }} >
                <MotifFileUploader
                    className="!h-[60vh]"
                    onDrop={onDrop as any}
                    label="Click to upload or drag and drop"
                    reactive
                >
                    <>
                        {({ getRootProps, getInputProps }) => (
                            <section>
                                <div {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <p>Drag 'n' drop some files here, or click to select files</p>
                                </div>
                            </section>
                        )}
                    </>
                    {file !== undefined && (
                        <MotifFileUploaderItem
                            fileName={file[0]?.path}
                            id={1}
                            onRemove={() => {
                                setFile(undefined)
                            }}
                            removable
                        />
                    )}
                </MotifFileUploader>
            </MotifFormField>
        )
    }, [file])
    return (
        <div>
            {renderFileSelect()}
        </div>
    )
}

export default ReportsUploadTemplate